import React, { Component } from 'react';
// import Button from "react-bootstrap/Button";

class AlphabetNavBar extends Component {
    constructor(props) {
        super(props);
        this.state = {
            alphabet: [],
          }
    }

    componentDidMount(){
        const chars = '1234567890ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('');

        this.setState({alphabet: chars})
    }

    render() { 
        const { alphabet } = this.state;

        return (
            <ul id="alphabet">
                {alphabet.map(char => <li className="alpha" key={char}>
                    <a className={this.props.selectedAlpha === char ? "alphaActive" : "alphaNormal"} href="#/" onClick={() => this.props.onCharChange(char)}>{char}</a></li>)}
            </ul>
          );
    }
}
 
export default AlphabetNavBar;